const messageTypes = {
  error: 'error',
  isLoadingPage: 'isLoadingPage',
  isLoadingCompleteQuote: 'isLoadingCompleteQuote'
}

export default messageTypes
